export default {
  site_name: 'CSSBuy Spreadsheet',
  home: 'Home',
  categories: 'Categories',
  guides: 'Guides',
  search: 'Search',
  search_placeholder: 'Search product, category or keyword...',
  language: 'Language',
  hero_title: 'CSSBuy Spreadsheet: Find and Compare Products',
  hero_subtitle: 'Explore the CSSBuy Spreadsheet, find products, compare options and see guides on QC, shipping, costs, warehouse, safety and buying.',
  explore_spreadsheet: 'Explore CSSBuy Spreadsheet',
  buy_now: 'Buy It Now',
  view_full_guide: 'View Full Guide',
  trust_text: 'Independent resource · Updated content · Organized research · PT-BR + English + Deutsch',
  popular_categories: 'Popular Categories',
  shoes: 'Shoes',
  hoodies_sweaters: 'Hoodies / Sweaters',
  t_shirts: 'T-Shirts',
  jackets: 'Jackets',
  pants_shorts: 'Pants / Shorts',
  headwear: 'Headwear',
  sets: 'Sets',
  underwear: 'Underwear',
  jersey: 'Jersey',
  accessories: 'Accessories',
  bags: 'Bags',
  belts: 'Belts',
  perfumes: 'Perfumes',
  other_stuff: 'Other Stuff',
  why_spreadsheet: 'Why Use the CSSBuy Spreadsheet?',
  organized_research: 'Organized Research',
  organized_research_desc: 'Find product information in a simple and organized structure.',
  compare_options: 'Compare Options',
  compare_options_desc: 'Compare categories, sellers and information before buying.',
  qc_guide: 'QC Guide',
  qc_guide_desc: 'Understand what points to check before confirming your purchase.',
  save_time: 'Save Time',
  save_time_desc: 'Find products with search and filters quickly and efficiently.',
  cssbuy_review: 'CSSBuy Review 2026',
  review_desc: 'Check information about features, QC, warehouse, shipping, costs and possible risks.',
  read_review: 'Read CSSBuy Review',
  shipping_cost: 'CSSBuy Shipping Cost',
  shipping_desc: 'Cost varies by weight, dimensions, destination and shipping method.',
  view_shipping_guide: 'View Shipping Guide',
  coupon: 'CSSBuy Coupon & Discount Code',
  coupon_desc: 'Check information about coupons and promotions. Always confirm validity directly on the platform.',
  view_coupons: 'View Coupons & Discounts',
  warehouse: 'CSSBuy Warehouse Guide',
  warehouse_desc: 'Understand storage, QC, consolidation and order preparation.',
  safety: 'Is CSSBuy Legit and Safe?',
  safety_desc: 'Explains risks related to sellers, payments, external links, QC, shipping, customs and refunds.',
  view_safety_guide: 'View CSSBuy Safety Guide',
  comparison: 'CSSBuy vs Other Platforms',
  comparison_desc: 'Compare CSSBuy, Superbuy, Sugargoo, Oopbuy, AllChinaBuy and other relevant platforms.',
  latest_articles: 'Latest Articles',
  faq: 'FAQ',
  faq_what_is: 'What is CSSBuy Spreadsheet?',
  faq_how_to_use: 'How to use CSSBuy Spreadsheet?',
  faq_legit: 'Is CSSBuy legitimate?',
  faq_safe: 'Is CSSBuy safe?',
  faq_shipping_cost: 'How much does shipping cost?',
  faq_qc: 'How does QC work?',
  faq_warehouse: 'What is Warehouse?',
  faq_find_products: 'How to find products?',
  faq_brazil: 'Does CSSBuy ship to Brazil?',
  faq_coupons: 'Where to find coupons?',
  final_cta: 'Ready to explore CSSBuy Spreadsheet?',
  final_cta_desc: 'Search products, compare information and check our guides before continuing to the main website.',
  footer_about: 'About',
  footer_contact: 'Contact',
  footer_disclaimer: 'Disclaimer',
  footer_privacy: 'Privacy',
  footer_terms: 'Terms',
  footer_rights: 'All rights reserved.',
  article_read_more: 'Read more',
  article_spreadsheet_guide: 'CSSBuy Spreadsheet 2026 — Complete Guide',
  article_spreadsheet_desc: 'Discover everything about CSSBuy Spreadsheet: how to find products, use filters, verify QC and compare prices. Updated guide for 2026.',
  article_shipping_guide: 'CSSBuy Shipping Cost Guide 2026',
  article_shipping_guide_desc: 'Understand shipping costs, available methods, delivery times and how to calculate freight to Brazil and Europe.',
  article_safety_guide: 'Is CSSBuy Safe? Safety Guide',
  article_safety_guide_desc: 'Complete analysis on safety, seller risks, payment protection and how to avoid problems.',
  spreadsheet_page_title: 'CSSBuy Spreadsheet 2026 — Complete Product & Buying Guide',
  what_is_spreadsheet: 'What is CSSBuy Spreadsheet?',
  how_it_works: 'How It Works',
  how_to_find: 'How to Find Products',
  product_categories: 'Product Categories',
  seller_research: 'Seller Research',
  latest_updates: 'Latest Updates',
  cta: 'Continue to Main Website',
  category_filter: 'Filter by Category',
  price_filter: 'Price',
  popularity_filter: 'Popularity',
  qc_filter: 'QC',
  seller_filter: 'Seller',
  update_filter: 'Update',
  streetwear: 'Streetwear',
  sportswear: 'Sportswear',
  clothing: 'Clothing',
  sneakers: 'Sneakers',
  back_to_home: 'Back to Home',
  published_date: 'Published',
  updated_date: 'Updated',
  author: 'Author',
  sources: 'Sources',
  related_articles: 'Related Articles',
  table_of_contents: 'Table of Contents',
  disclaimer_text: 'This is an independent information website and is not the official CSSBuy website. All external links lead to the main website.',
  view_guide: 'View Guide',
  continue_to_main: 'Continue to Main Website',
  learn_more: 'Learn more',
  read_article: 'Read Article',
  see_all: 'See all',
  search_results: 'Search Results',
  no_results: 'No results found',
  all_categories: 'All Categories',
  spreadsheet_seo_title: 'CSSBuy Spreadsheet 2026 — Find and Compare Products',
  spreadsheet_seo_desc: 'Explore CSSBuy Spreadsheet, find products, compare options and see guides on QC, shipping, costs, warehouse, safety and buying.',
  article_category_spreadsheet: 'CSSBuy Spreadsheet',
  article_category_shipping: 'Shipping',
  article_category_safety: 'Safety',
  article_category_review: 'Review',
  article_category_coupon: 'Coupons',
  article_category_warehouse: 'Warehouse',
  article_category_qc: 'Quality Control',
  article_category_comparison: 'Comparison',
  article_category_beginner: 'Beginner Guide',
  shopping_guide: 'Shopping Guide',
  latest_articles_desc: 'Original buying guides, reviews and shipping resources for CSSBuy Spreadsheet users.',
  categories_desc: 'Browse every product category on the CSSBuy Spreadsheet and jump straight to what you need.',
  article_review_title: 'CSSBuy Review 2026: Fees, QC, Shipping & Safety',
  article_review_desc: 'Honest CSSBuy review covering fees, QC photos, warehouse, shipping costs and safety. Is CSSBuy legit? Read our 2026 analysis.',
  article_coupon_title: 'CSSBuy Coupon & Discount Code 2026 Guide',
  article_coupon_desc: 'Find CSSBuy coupon and discount code information for 2026. Learn how promotions work and how to verify current deals.',
  article_warehouse_title: 'CSSBuy Warehouse Guide: Storage, QC & Shipping',
  article_warehouse_desc: 'Complete CSSBuy warehouse guide covering storage, QC inspection, consolidation and parcel preparation before shipping.',
  article_qc_title: 'CSSBuy QC Guide: How to Read QC Photos',
  article_qc_desc: 'Learn how to read CSSBuy QC photos and spot quality issues before shipping. Complete QC checklist for shoes and clothing.',
  article_alternatives_title: 'CSSBuy Alternatives 2026: Superbuy, Sugargoo & More',
  article_alternatives_desc: 'Compare CSSBuy with Superbuy, Sugargoo, Oopbuy and AllChinaBuy. Find the best agent service for your needs in 2026.',
  article_beginner_title: 'How to Use CSSBuy Spreadsheet: Beginner Guide',
  article_beginner_desc: 'New to CSSBuy? This beginner guide explains how to use the spreadsheet, find products, check QC and ship your first order.',
  article_brazil_title: 'CSSBuy Shipping to Brazil: Costs & Customs Guide',
  article_brazil_desc: 'CSSBuy shipping to Brazil explained: methods, costs, delivery times and customs duties. Complete guide for Brazilian buyers.',
  article_germany_title: 'CSSBuy Shipping to Germany: Costs & Methods',
  article_germany_desc: 'CSSBuy shipping to Germany: available methods, costs, delivery times and customs information for German buyers.',
  article_shoes_title: 'CSSBuy Spreadsheet Shoes: Best Sneaker Finds',
  article_shoes_desc: 'Discover the best shoes and sneakers on the CSSBuy Spreadsheet. Browse popular finds, compare sellers and check QC.',
  article_hoodies_title: 'CSSBuy Spreadsheet Hoodies: Best Finds & Guide',
  article_hoodies_desc: 'Browse the best hoodies and sweaters on the CSSBuy Spreadsheet. Find popular styles, compare sellers and check QC photos.',
  featured_products: 'Featured Products',
  featured_products_desc: 'Handpicked products from the CSSBuy Spreadsheet. Click any item to view details and purchase.',
  all_products: 'View All Products',
  products: 'Products',
  filter_all: 'All',
  back_to_top: 'Back to Top',
  products_title: 'CSSBuy Spreadsheet Products',
  products_subtitle: 'Explore all products from the CSSBuy Spreadsheet. Filter by category and click any item to view details and purchase.',
};